export default __webpack_public_path__ + "static/media/mano_mano.9fea50f3.png";